import {
  ApiAction,
  ApiRequestAction,
  ApiSuccessAction,
  ApiFailureAction,
} from 'lib/types/global';

export const API_READ_ORDER_SUMMARY = 'GET_RESTAURANT_ORDER_SUMMARY';
export const API_READ_ORDER_SUMMARY_REQUEST =
  'GET_RESTAURANT_ORDER_SUMMARY_REQUEST';
export const API_READ_ORDER_SUMMARY_SUCCESS =
  'GET_RESTAURANT_ORDER_SUMMARY_SUCCESS';
export const API_READ_ORDER_SUMMARY_FAILURE =
  'GET_RESTAURANT_ORDER_SUMMARY_FAILURE';
export const API_READ_ORDER_SUMMARY_PREVIOUS =
  'GET_RESTAURANT_ORDER_SUMMARY_PREVIOUS';
export const API_READ_ORDER_SUMMARY_REQUEST_PREVIOUS =
  'GET_RESTAURANT_ORDER_SUMMARY_REQUEST_PREVIOUS';
export const API_READ_ORDER_SUMMARY_SUCCESS_PREVIOUS =
  'GET_RESTAURANT_ORDER_SUMMARY_SUCCESS_PREVIOUS';
export const API_READ_ORDER_SUMMARY_FAILURE_PREVIOUS =
  'GET_RESTAURANT_ORDER_SUMMARY_FAILURE_PREVIOUS';
export const API_READ_RESTAURANT_ORDERS = 'GET_RESTAURANT_ORDERS';
export const API_READ_RESTAURANT_ORDERS_REQUEST =
  'GET_RESTAURANT_ORDERS_REQUEST';
export const API_READ_RESTAURANT_ORDERS_SUCCESS =
  'GET_RESTAURANT_ORDERS_SUCCESS';
export const API_READ_RESTAURANT_ORDERS_FAILURE =
  'GET_RESTAURANT_ORDERS_FAILURE';
export const API_READ_MORE_RESTAURANT_ORDERS = 'GET_MORE_RESTAURANT_ORDERS';
export const API_READ_MORE_RESTAURANT_ORDERS_REQUEST =
  'GET_MORE_RESTAURANT_ORDERS_REQUEST';
export const API_READ_MORE_RESTAURANT_ORDERS_SUCCESS =
  'GET_MORE_RESTAURANT_ORDERS_SUCCESS';
export const API_READ_MORE_RESTAURANT_ORDERS_FAILURE =
  'GET_MORE_RESTAURANT_ORDERS_FAILURE';

// Restaurant hours insinghts actions
export const API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS =
  'FETCH_RETAURANT_OPEN_HOURS_INSIGHTS';
export const API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_REQUEST =
  'FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_REQUEST';
export const API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_SUCCESS =
  'FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_SUCCESS';
export const API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_FAILURE =
  'FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_FAILURE';

export type API_READ_ORDER_SUMMARY = typeof API_READ_ORDER_SUMMARY;
export type API_READ_ORDER_SUMMARY_REQUEST = typeof API_READ_ORDER_SUMMARY_REQUEST;
export type API_READ_ORDER_SUMMARY_SUCCESS = typeof API_READ_ORDER_SUMMARY_SUCCESS;
export type API_READ_ORDER_SUMMARY_FAILURE = typeof API_READ_ORDER_SUMMARY_FAILURE;
export type API_READ_ORDER_SUMMARY_PREVIOUS = typeof API_READ_ORDER_SUMMARY_PREVIOUS;
export type API_READ_ORDER_SUMMARY_REQUEST_PREVIOUS = typeof API_READ_ORDER_SUMMARY_REQUEST_PREVIOUS;
export type API_READ_ORDER_SUMMARY_SUCCESS_PREVIOUS = typeof API_READ_ORDER_SUMMARY_SUCCESS_PREVIOUS;
export type API_READ_ORDER_SUMMARY_FAILURE_PREVIOUS = typeof API_READ_ORDER_SUMMARY_FAILURE_PREVIOUS;
export type API_READ_RESTAURANT_ORDERS = typeof API_READ_RESTAURANT_ORDERS;
export type API_READ_RESTAURANT_ORDERS_REQUEST = typeof API_READ_RESTAURANT_ORDERS_REQUEST;
export type API_READ_RESTAURANT_ORDERS_SUCCESS = typeof API_READ_RESTAURANT_ORDERS_SUCCESS;
export type API_READ_RESTAURANT_ORDERS_FAILURE = typeof API_READ_RESTAURANT_ORDERS_FAILURE;
export type API_READ_MORE_RESTAURANT_ORDERS = typeof API_READ_MORE_RESTAURANT_ORDERS;
export type API_READ_MORE_RESTAURANT_ORDERS_REQUEST = typeof API_READ_MORE_RESTAURANT_ORDERS_REQUEST;
export type API_READ_MORE_RESTAURANT_ORDERS_SUCCESS = typeof API_READ_MORE_RESTAURANT_ORDERS_SUCCESS;
export type API_READ_MORE_RESTAURANT_ORDERS_FAILURE = typeof API_READ_MORE_RESTAURANT_ORDERS_FAILURE;

export type API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS = typeof API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS;
export type API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_REQUEST = typeof API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_REQUEST;
export type API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_SUCCESS = typeof API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_SUCCESS;
export type API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_FAILURE = typeof API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_FAILURE;

type ApiReadOrderSummaryAction = ApiAction<API_READ_ORDER_SUMMARY>;
type ApiReadOrderSummaryRequestAction = ApiRequestAction<
  API_READ_ORDER_SUMMARY_REQUEST
>;
type ApiReadOrderSummarySuccessAction = ApiSuccessAction<
  API_READ_ORDER_SUMMARY_SUCCESS,
  {}
>;
type ApiReadOrderSummaryFailureAction = ApiFailureAction<
  API_READ_ORDER_SUMMARY_FAILURE,
  {}
>;

type ApiReadOrderSummaryActionPrevious = ApiAction<
  API_READ_ORDER_SUMMARY_PREVIOUS
>;
type ApiReadOrderSummaryRequestActionPrevious = ApiRequestAction<
  API_READ_ORDER_SUMMARY_REQUEST_PREVIOUS
>;
type ApiReadOrderSummarySuccessActionPrevious = ApiSuccessAction<
  API_READ_ORDER_SUMMARY_SUCCESS_PREVIOUS,
  {}
>;
type ApiReadOrderSummaryFailureActionPrevious = ApiFailureAction<
  API_READ_ORDER_SUMMARY_FAILURE_PREVIOUS,
  {}
>;

type ApiReadRestaurantOrdersAction = ApiAction<
  API_READ_RESTAURANT_ORDERS | API_READ_MORE_RESTAURANT_ORDERS
>;
type ApiReadRestaurantOrdersRequestAction = ApiRequestAction<
  API_READ_RESTAURANT_ORDERS_REQUEST | API_READ_MORE_RESTAURANT_ORDERS_REQUEST
>;
type ApiReadRestaurantOrdersSuccessAction = ApiSuccessAction<
  API_READ_RESTAURANT_ORDERS_SUCCESS | API_READ_MORE_RESTAURANT_ORDERS_SUCCESS,
  any
>;
type ApiReadRestaurantOrdersFailureAction = ApiFailureAction<
  API_READ_RESTAURANT_ORDERS_FAILURE | API_READ_MORE_RESTAURANT_ORDERS_FAILURE,
  any
>;

type ApiFetchRestaurantOpenHoursInsightsAction = ApiAction<
  API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS
>;
type ApiFetchRestaurantOpenHoursInsightsRequestAction = ApiRequestAction<
  API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_REQUEST
>;

interface Event {
  type: string;
  startDateLocal: string;
  startTimeOfDayLocal: string;
  durationMinutes: string;
}

export interface RestaurantOpenHoursInsightsPayload {
  availabilityBreakdownPercents: {
    available: number;
    closed: number;
    disconnected: number;
  };
  branchNotAvailableEvents: Array<Event>;
  totalAvailableOpeningMinutes: number;
  totalScheduledOpeningMinutes: number;
}

type ApiFetchRestaurantOpenHoursInsightsSuccessAction = ApiSuccessAction<
  API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_SUCCESS,
  {
    data: RestaurantOpenHoursInsightsPayload;
  }
>;
type ApiFetchRestaurantOpenHoursInsightsFailureAction = ApiFailureAction<
  API_FETCH_RETAURANT_OPEN_HOURS_INSIGHTS_FAILURE
>;

export type OpenRestaurantHoursInsightsActions =
  | ApiFetchRestaurantOpenHoursInsightsAction
  | ApiFetchRestaurantOpenHoursInsightsRequestAction
  | ApiFetchRestaurantOpenHoursInsightsSuccessAction
  | ApiFetchRestaurantOpenHoursInsightsFailureAction;

export type RestaurantAction =
  | ApiReadOrderSummaryAction
  | ApiReadOrderSummaryRequestAction
  | ApiReadOrderSummarySuccessAction
  | ApiReadOrderSummaryFailureAction
  | ApiReadOrderSummaryActionPrevious
  | ApiReadOrderSummaryRequestActionPrevious
  | ApiReadOrderSummarySuccessActionPrevious
  | ApiReadOrderSummaryFailureActionPrevious
  | ApiReadRestaurantOrdersAction
  | ApiReadRestaurantOrdersRequestAction
  | ApiReadRestaurantOrdersSuccessAction
  | ApiReadRestaurantOrdersFailureAction
  | OpenRestaurantHoursInsightsActions;
